import { supabase } from "@/integrations/supabase/client";

/**
 * Get a signed URL for a private audio file.
 * Falls back to audio_url if no storage path is available (legacy data).
 */
export async function getAudioUrl(
  audioStoragePath: string | null,
  audioUrl: string | null
): Promise<string | null> {
  if (audioStoragePath) {
    const { data, error } = await supabase.storage
      .from("visualization-audio")
      .createSignedUrl(audioStoragePath, 3600); // 1 hour
    if (!error && data?.signedUrl) return data.signedUrl;
  }
  // Fallback to legacy public URL
  return audioUrl || null;
}
